import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import './styles/videoPlayer.scss'
import ReactPlayer from 'react-player';
import { ApiHelper } from '../../apiHelper/ApiHelper';
import { isAbsoluteUrl, resolveFileUrl } from '../../Constants';
import useWindowDimensions from '../../hooks/size';

export default function VideoPlayer() {
    const api = new ApiHelper();
    const storedUrl = localStorage.getItem("url");
    const { width } = useWindowDimensions();
    const [videoUrl, setVideoUrl] = useState<string>();
    const [failed, setFailed] = useState(false);

    // Uploaded videos are pulled through the auth-gated endpoint (as an in-memory
    // blob), not the public files URL — so the originals can't be downloaded or
    // shared by link, consistent with the PDF viewer. External links (YouTube,
    // Vimeo, an absolute URL the admin pasted) are played directly.
    useEffect(() => {
        let objectUrl: string | undefined;
        let revoked = false;
        (async () => {
            if (!storedUrl) { setFailed(true); return; }
            if (isAbsoluteUrl(storedUrl)) {
                setVideoUrl(resolveFileUrl(storedUrl)?.toString());
                return;
            }
            try {
                const blob = await api.fetchProtectedFile(storedUrl);
                if (revoked) return;
                objectUrl = URL.createObjectURL(blob);
                setVideoUrl(objectUrl);
            } catch (x: any) {
                api.processErrors(x);
                setFailed(true);
            }
        })();
        return () => { revoked = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [storedUrl]);

    useEffect(() => {
        const handleContextmenu = (e: MouseEvent) => { e.preventDefault(); };
        document.addEventListener('contextmenu', handleContextmenu)
        return function cleanup() {
            document.removeEventListener('contextmenu', handleContextmenu)
        }
    }, [])

    // A missing/broken source otherwise renders a silent empty player — show a
    // Czech failure state with a way back to the lesson instead.
    const unavailable = !storedUrl || failed;

    return (
        <div className="videoPlayer">
            {unavailable
                ? <div className="viewerMsg">
                    <p>Video se nepodařilo načíst.</p>
                    <Link to=".." className="msgBack">← Zpět na lekci</Link>
                  </div>
                : videoUrl
                    ? <ReactPlayer className="player" width={(width > 1250) ? 1200 : width - 15} height={"auto"} controls={true} url={videoUrl} onError={() => setFailed(true)} />
                    : <div className="viewerMsg"><p>Načítání videa…</p></div>
            }

            <Link to=".." className="back"><img src="/images/common/back.png" alt="" /></Link>
        </div>
    );
}
